/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { task, Task } from 'ember-concurrency';
import FormValidations from 'cio/utils/form-validations';
import UserPasswordValidations from 'cio/utils/validations/user-password-with-current';
import UserModel from 'cio/models/user';

type SettingsTeamSetPasswordFormArgs = {
  user: UserModel;
  onCancel: () => unknown;
  onSubmit: (user: UserModel, newPassword: string, currentPassword: string) => unknown;
};

interface SettingsTeamSetPasswordFormSignature {
  Element: HTMLFormElement;
  Args: SettingsTeamSetPasswordFormArgs;
}

interface SetPasswordFormValues {
  currentPassword: string;
  password: string;
  passwordConfirmation: string;
}

export default class SettingsTeamSetPasswordForm extends Component<SettingsTeamSetPasswordFormSignature> {
  @tracked passwordTouched = false;
  @tracked passwordConfirmationTouched = false;
  @tracked currentPasswordTouched = false;
  @tracked formValues: SetPasswordFormValues = {
    currentPassword: '',
    password: '',
    passwordConfirmation: '',
  };
  @tracked validations!: FormValidations;

  constructor(owner: unknown, args: SettingsTeamSetPasswordFormArgs) {
    super(owner, args);

    this.validations = FormValidations.create({
      validations: UserPasswordValidations,
      context: this,
      modelKey: 'formValues',
    });
  }

  submitTask = task(async (ev) => {
    ev.preventDefault();

    await this.validations.validateModel();
    await this.args.onSubmit(this.args.user, this.formValues.password, this.formValues.currentPassword);
  });

  @action
  onPasswordBlur() {
    this.passwordTouched =
      this.passwordTouched || (this.formValues.password != null && this.formValues.password !== '');
  }

  @action
  setPassword(validationTask: Task<unknown, [string]>, value: string) {
    this.formValues = {
      ...this.formValues,
      password: value,
    };
    this.validatePassword(value, validationTask);
  }

  @action
  setPasswordConfirmation(value: string) {
    this.formValues = {
      ...this.formValues,
      passwordConfirmation: value,
    };
    this.passwordConfirmationTouched = true;
    this.validations.validateAttribute('passwordConfirmation');
  }

  @action
  setCurrentPassword(value: string) {
    this.formValues = {
      ...this.formValues,
      currentPassword: value,
    };
    this.currentPasswordTouched = true;
    this.validations.validateAttribute('currentPassword');
  }

  @action
  validatePassword(password: string, validationTask: Task<unknown, [string]>) {
    validationTask.perform(password);
    this.validations.validateAttribute('password');
  }
}
